import React from 'react'
import { NextWrapper } from 'data-fetching-wrapper'
import { print } from 'graphql'
import { grapheneGetTranslated } from 'utils'
import { initializeApollo } from '@gql/client'
import { PaginaDocument, CategoriaDocument } from '@gql/graphql'
import { ListingCollezioniCompletaDocument } from '@gql/graphql-get'
import { Page } from '@components/organisms'
import { ListingTemplate } from '@components/templates'
import { fromParsedUrlToParams } from '@utils/listing'

const CollezioniListing = ({ pagina, listing, categoria }) => (
  <ListingTemplate pagina={pagina} listing={listing} categoria={categoria} />
)

export const getServerSideProps = NextWrapper.getServerSideProps(
  async ({ params: { slug }, query, locale, preview, previewData, req, res }) => {
    // caso con query che contiene solo slug
    // query: { slug: [ 'effetto', 'legno' ]

    // caso con query che contiene solo filtro
    // query: {ambiente: '12,12,21',}

    // caso con query che contiene sia slug che filtro
    // query: {
    //   ambiente: '12,12,21',
    //   slug: [ 'effetto', 'legno' ]
    // }

    const client = initializeApollo(locale)

    const headers = preview && previewData?.headers ? { cookie: previewData.headers } : {}

    const {
      data: { categoria },
    } = await client.query({
      query: CategoriaDocument,
      variables: {
        slug1: slug && slug.length > 0 ? slug[0] : 'collezioni',
        slug2: slug && slug.length > 1 ? slug[1] : 'collezioni',
      },
      context: {
        headers,
      },
    })

    if (!categoria && slug && slug.length > 0) {
      return {
        notFound: true,
      }
    }

    let chiavePagina = 'collezioni'
    let optionalParams = {}
    if (categoria && slug && slug.length > 0) {
      optionalParams = {
        contentTypeId: categoria.modelPk,
        objectId: categoria.pk,
      }
      chiavePagina = `${categoria.macrocategoria.chiaveRicerca}-listing`
    }

    const {
      data: { pagina },
    } = await client.query({
      query: PaginaDocument,
      variables: {
        ...optionalParams,
        chiave: chiavePagina,
        preview,
      },
      context: {
        headers,
      },
    })

    if (!pagina) {
      return {
        notFound: true,
      }
    }

    // recuperare i dati dal query string
    const listingDefaultParams = {
      params: fromParsedUrlToParams(query, false, categoria),
    }

    const encodedVariables = encodeURIComponent(JSON.stringify(listingDefaultParams))
    const encodedQuery = encodeURIComponent(print(ListingCollezioniCompletaDocument))

    const response = await grapheneGetTranslated(locale).get(
      `?lang=${locale}&query=${encodedQuery}&operationName=ListingCollezioniCompleta&variables=${encodedVariables}`
    )
    const { data } = response.data

    const listingCollezioni = data?.listingCollezioni

    if (!listingCollezioni) {
      return {
        notFound: true,
      }
    }

    res.setHeader('Cache-Control', 'public, s-maxage=60, stale-while-revalidate')
    return {
      props: { pagina, listing: listingCollezioni, categoria },
    }
  }
)

export default CollezioniListing
